















import { bemBuilder } from "@/v2/util/bem-builder";
import { boolean, func, string } from "@/v2/util/prop/type";
import { computed, defineComponent, onMounted } from "@vue/composition-api";
import { IAtomTextareaProps } from "./props";

const css = bemBuilder("atom-textarea");

/**
 * @deprecated
 * use `AutoSizeTextarea` from `v2/new-design-system` instead
 */

export default defineComponent<IAtomTextareaProps>({
  name: "AtomTextarea",
  inheritAttrs: false,
  props: {
    value: string().isRequired().use(),
    error: boolean().use(),
    onChange: func().use(),
  },
  setup(props, ctx) {
    ctx.root.$listeners;

    const listeners = computed(() => {
      return {
        ...ctx.root.$listeners,
        input: (event: any) => props.onChange(event.target.value),
      };
    });

    onMounted(() => props.onChange(props.value));

    return {
      listeners,
      css,
    };
  },
});
